import { createReducer, on } from "@ngrx/store";
import { initialCameraState } from "../camera.state";
import { CameraActions } from "../camera.actions";
import { onLoadableLoad } from "../../../models";
import { arrayToILoadableWrapperArray, createDefaultILoadableArray, createDefaultLoadable, onLoadableError, onLoadableSuccess, toLoadableWrapper } from "../../../models/loadable";
import { removeItem, replaceItem } from "../../common";
import { UserActions } from "../../user/user.actions";

export const scheduleReducer = createReducer(
    initialCameraState,
    on(CameraActions.loadSchedules, (state, { sensor }) => ({
        ...state,
        schedules: {
            ...state.schedules,
            [sensor.id]: {
                ...onLoadableLoad({ ...(state.schedules[sensor.id] ?? createDefaultILoadableArray()) })
            }
        }
    })),
    on(CameraActions.loadSchedulesSuccess, (state, { sensor, schedules }) => ({
        ...state,
        schedules: {
            ...state.schedules,
            [sensor.id]: {
                ...onLoadableSuccess({ ...(state.schedules[sensor.id]) }), items: arrayToILoadableWrapperArray(schedules)
            }
        }
    })),
    on(CameraActions.loadSchedulesFailure, (state, { sensor, error }) => ({
        ...state,
        schedules: {
            ...state.schedules,
            [sensor.id]: {
                ...onLoadableError({ ...(state.schedules[sensor.id]) }, error)
            }
        }
    })),
    on(CameraActions.createSchedule, (state, { schedule, sensor }) => ({
        ...state,
        schedules: {
            ...state.schedules,
            [sensor.id]: {
                ...state.schedules[sensor.id],
                items: [...state.schedules[sensor.id].items, {
                    ...onLoadableLoad({ ...schedule, ...createDefaultLoadable() })
                }]
            }
        }
    })),
    on(CameraActions.createScheduleSuccess, (state, { schedule, sensor }) => ({
        ...state,
        schedules: {
            ...state.schedules,
            [sensor.id]: {
                ...state.schedules[sensor.id],
                items: [...state.schedules[sensor.id].items.filter(e => e.id !== undefined && e.id !== ""), onLoadableSuccess(toLoadableWrapper({ ...schedule }))]
            }
        }
    })),
    on(CameraActions.createScheduleError, (state, { sensorId, error }) => ({
        ...state,
        schedules: {
            ...state.schedules,
            [sensorId]: {
                ...state.schedules[sensorId],
                items: [...state.schedules[sensorId].items.filter(e => e.id !== undefined)]
            }
        }
    })),
    on(CameraActions.updateSchedule, (state, { schedule, sensor }) => ({
        ...state,
        schedules: {
            ...state.schedules,
            [sensor.id]: {
                ...state.schedules[sensor.id],
                items: replaceItem(state.schedules[sensor.id].items, onLoadableLoad(toLoadableWrapper({ ...schedule })))
            }
        }
    })),
    on(CameraActions.updateScheduleSuccess, (state, { schedule, sensor }) => ({
        ...state,
        schedules: {
            ...state.schedules,
            [sensor.id]: {
                ...state.schedules[sensor.id],
                items: replaceItem(state.schedules[sensor.id].items, onLoadableSuccess(toLoadableWrapper({ ...schedule })))
            }
        }
    })),
    on(CameraActions.updateScheduleError, (state, { sensorId, error }) => ({
        ...state,
        schedules: {
            ...state.schedules,
            [sensorId]: {
                ...state.schedules[sensorId],
                items: [...state.schedules[sensorId].items.filter(e => e.id !== undefined)]
            }
        }
    })),
    on(CameraActions.deleteSchedule, (state, { schedule, sensor }) => ({
        ...state,
        schedules: {
            ...state.schedules,
            [sensor.id]: {
                ...state.rules[sensor.id],
                items: replaceItem(state.schedules[sensor.id].items, onLoadableLoad(toLoadableWrapper({ ...schedule })))
            }
        }
    })),
    on(CameraActions.deleteScheduleSuccess, (state, { schedule, sensor }) => ({
        ...state,
        schedules: {
            ...state.schedules,
            [sensor.id]: {
                ...state.schedules[sensor.id],
                items: removeItem(state.schedules[sensor.id].items, schedule.id)
            }
        }
    })),
    on(CameraActions.deleteScheduleError, (state, { schedule, sensor, error }) => ({
        ...state,
        schedules: {
            ...state.schedules,
            [sensor.id]: {
                ...state.schedules[sensor.id],
                items: replaceItem(state.schedules[sensor.id].items, onLoadableError(toLoadableWrapper(state.schedules[sensor.id].items.filter(e => e.id === schedule.id)[0]), error))
            }
        }
    })),

    on(UserActions.logout, _ => ({ ...initialCameraState })),
);